/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {
    IIceIceYetiGameData,
    IIceIceYetiInitData,
    IIceIceYetiServerData,
    IWildInfoData
} from "./data/IIceIceYetiServerData";
import {IWildInfo} from "./IWildInfo";
import {IReelsWin} from "./IReelsWin";

export class IceIceYetiServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }

    public parseOverlayWildsBeforeSpin(rawData:IIceIceYetiServerData):boolean[][] {
        return rawData.overlayWildsBeforeSpin;
    }

    public parseOverlayWildsAfterSpin(rawData:IIceIceYetiGameData):boolean[][] {
        return rawData.overlayWildsAfterSpin;
    }

    public parseOverlaySymbolsBeforeSpin(rawData:IIceIceYetiGameData):string[][] {
        return rawData.overlaySymbolsBeforeSpin;
    }

    public parseOverlaySymbols(rawData:IIceIceYetiInitData):string[][] {
        return rawData.overlaySymbols;
    }

    public parseOverlaySymbolsAfterSpin(rawData:IIceIceYetiGameData):string[][] {
        return rawData.overlaySymbolsAfterSpin;
    }

    public parseActiveGameAreaBeforeSpin(rawData:IIceIceYetiServerData):boolean[][] {
        return rawData.activeGameAreaBeforeSpin;
    }

    public parseActiveGameAreaAfterSpin(rawData:IIceIceYetiGameData):boolean[][] {
        return rawData.activeGameAreaAfterSpin;
    }

    public parseNearWinReelsIntense(rawData:IIceIceYetiGameData):boolean[] {
        return rawData.nearWinReelsIntense;
    }

    public parseWildInfoList(serverWildInfo:IWildInfoData[]):IWildInfo[] {
        const wildInfoList:IWildInfo[] = [];
        let numberToOpen:number;
        let wildPosition:PIXI.Point;

        for(let i:number = 0; i < serverWildInfo.length; i++) {
            let tempWildInfo:number[][] = serverWildInfo[i].areaOpenPositions;
            let openPositions:PIXI.Point[] = [];
            for(let j:number = 0; j < tempWildInfo.length; j++) {
                openPositions.push(new PIXI.Point(tempWildInfo[j][0], tempWildInfo[j][1]));
            }

            numberToOpen = serverWildInfo[i].numberOfPositionToOpen;

            wildPosition = new PIXI.Point(serverWildInfo[i].wildPosition[0], serverWildInfo[i].wildPosition[1]);

            wildInfoList.push({
                areaOpenPositions : openPositions,
                numberOfPositionsToOpen : numberToOpen,
                wildPosition : wildPosition
            });
        }
        return wildInfoList;
    }

    public parseAllWinPositions(rawData:IIceIceYetiGameData):boolean[][] {
        let allWinPositions:boolean[][] = [[false, false, false, false, false, false, false], [false, false, false, false, false, false, false], [false, false, false, false, false, false, false], [false, false, false, false, false, false, false], [false, false, false, false, false, false, false]];
        for(let wins of rawData.betWayWins!) {
            for(let i:number = 0; i < wins.reelWinPositions.length; i++) {
                for(let j:number = 0; j < wins.reelWinPositions[i].length; j++) {
                    if(wins.reelWinPositions[i][j] == true) {
                        allWinPositions[i][j] = true;
                    }
                }
            }
        }
        return allWinPositions;
    }

    public parseReelWinPositions(rawData:IIceIceYetiGameData):IReelsWin[] {
        let allReelWinPositions:IReelsWin[] = [];
        for(let wins of rawData.betWayWins!) {
            allReelWinPositions.push({
                symbolName : wins.symbol,
                reelWinPositions : wins.reelWinPositions
            });
        }
        return allReelWinPositions;
    }

    public parseRandomFeatureTriggered(rawData:IIceIceYetiGameData):boolean {
        return rawData.randomFeatureTriggered;
    }

    public parseActiveGameAreaAfterRandomTrigger(rawData:IIceIceYetiGameData):boolean[][] {
        return rawData.activeGameAreaAfterRandomTrigger;
    }

    public parseRandomFeatureOpenPositions(rawData:IIceIceYetiGameData):PIXI.Point[] | null {
        // random feature cannot be triggered in respin, so no need to check the previous open positions.
        if(rawData.activeGameAreaAfterRandomTrigger) {
            let result:PIXI.Point[] = [];
            rawData.activeGameAreaAfterRandomTrigger.forEach((symbolPositionsData:boolean[], reelId:number) => {
                symbolPositionsData.forEach((openData:boolean, symbolId:number) => {
                    if(openData && (symbolId < 2 || symbolId > 4)) {
                        result.push(new PIXI.Point(reelId, symbolId));
                    }
                });
            });

            return result;
        } else {
            return null;
        }
    }
}